












import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IFormControl } from '@/entities/form.interface';

@Component({
    inject: ['$validator']
})
export default class InputComponent extends Vue {
    @Prop() public control: IFormControl;

    @Prop() public disabled: boolean;

    @Prop() public type: string;
}
